module.exports = __webpack_public_path__ + "static/media/77.46cc305c.jpg";